import './InitialScreen.scss'
import React, { useEffect, useRef } from 'react'
import { VelvetLogo } from '@assets/index'
import InitialScreenContent from '@components/InitialScreen/InitialScreenContent/InitialScreenContent'
import Image from '@components/Image/Image'
import { ImageSize } from '@enums/images.enum'
import { useImgUrlTransform } from '@hooks/useImgUrlTransform'
import { VelvetSDK } from 'sdk'

interface InitialScreenProps {
  showMenu: (status: boolean) => void
}

const InitialScreen = ({ showMenu }: InitialScreenProps) => {
  const loginButtonRef = useRef<HTMLButtonElement>(null)
  const config = VelvetSDK.Configuration.configuration
  const background = config?.welcomeBackgroundImage
  const transformedImage = useImgUrlTransform(background ?? '', ImageSize.HERO)

  useEffect(() => {
    showMenu(false)
    loginButtonRef.current?.focus()
  }, [showMenu])

  return (
    <div className="initial-screen">
      <div className="background-img">
        <Image image={transformedImage} alt="Initial screen background" fallbackOnLoad />
      </div>
      <VelvetLogo />
      <InitialScreenContent focusedBtn={loginButtonRef} />
    </div>
  )
}

export default InitialScreen
